export default function Marquee({ items = [] }) {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-serif italic text-lg sm:text-xl tracking-wide text-navy/80 whitespace-nowrap">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-cherry shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-navy/10 bg-sky/20 py-5">
      <div className="marquee-track">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
